import { useEffect } from 'react';

/**
 * Warnt vor dem Verlassen der Seite (Reload / Tab schließen / Browser-zurück auf
 * externe Seite), solange `active` true ist — z. B. während einer laufenden
 * KI-Generierung, damit kein Zwischenstand verloren geht.
 *
 * Deckt nur Browser-Navigation ab; In-App-Navigation (SPA) muss separat
 * abgesichert werden (siehe Guard in App.navigateTo / Wizard-„Speichern & Schließen").
 */
export function useUnloadWarning(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Chrome verlangt returnValue; der Text ist browserseitig generisch.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [active]);
}
